import { API_ENDPOINTS } from '../config/api';

export interface SubscriptionDetails {
  email: string;
  payment_amount: number;
  payment_processor: string;
  package_name: string;
  billing_cycle: string;
  currency: string;
  timestamp: string;
  start_date: string;
  expiration_date: string;
  subscription_id?: string;
}

export interface SubscriptionResponse {
  success: boolean;
  message?: string;
  subscription_status?: 'active' | 'expired' | 'na';
  subscription_details?: SubscriptionDetails[];
}

export const subscriptionService = {
  async getSubscriptionDetails(token: string): Promise<SubscriptionResponse> {
    try {
      const response = await fetch(API_ENDPOINTS.SUBSCRIPTION.DETAILS, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching subscription details:', error);
      return {
        success: false,
        message: 'Failed to fetch subscription details',
      };
    }
  },
};